import { createSlice } from '@reduxjs/toolkit';
import {
  cleanupCache,
  invalidateCacheByPattern,
  CACHE_CONFIGS
} from '../../utils/cacheUtils';

const initialState = {
  healthParams: {},
  appointments: {},
  lipidProfile: {},
  medicalHistory: {},
  profiles: {},
  // Track cache statistics for debugging
  stats: {
    hits: 0,
    misses: 0,
    invalidations: 0
  }
};

const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    // Set cache entry
    setCacheEntry: (state, action) => {
      // const { cacheType, key, data } = action.payload;

      // if (!state[cacheType]) {
      //   state[cacheType] = {};
      // }

      // state[cacheType][key] = {
      //   data,
      //   timestamp: Date.now()
      // };

      // // Cleanup old entries if cache size exceeds limit
      // const config = CACHE_CONFIGS[cacheType.toUpperCase()];
      // if (config && config.maxSize) {
      //   state[cacheType] = cleanupCache(state[cacheType], config.maxSize);
      // }
      console.log("FE caching called")
    },

    // Get cache entry (this is mainly for tracking cache hits)
    getCacheEntry: (state, action) => {
      const { cacheType, key } = action.payload;

      if (state[cacheType] && state[cacheType][key]) {
        state.stats.hits += 1;
        return state[cacheType][key];
      } else {
        state.stats.misses += 1;
        return null;
      }
    },

    // Remove specific cache entry
    removeCacheEntry: (state, action) => {
      const { cacheType, key } = action.payload;

      if (state[cacheType] && state[cacheType][key]) {
        delete state[cacheType][key];
        state.stats.invalidations += 1;
      }
    },

    // Clear entire cache type
    clearCacheType: (state, action) => {
      const { cacheType } = action.payload;

      if (state[cacheType]) {
        const keysCount = Object.keys(state[cacheType]).length;
        state[cacheType] = {};
        state.stats.invalidations += keysCount;
      }
    },

    // Invalidate cache by pattern
    invalidateByPattern: (state, action) => {
      const { cacheType, pattern } = action.payload;

      if (state[cacheType]) {
        const oldKeysCount = Object.keys(state[cacheType]).length;
        state[cacheType] = invalidateCacheByPattern(state[cacheType], pattern);
        const newKeysCount = Object.keys(state[cacheType]).length;
        state.stats.invalidations += (oldKeysCount - newKeysCount);
      }
    },

    // Clear all cache (useful for logout)
    clearAllCache: (state) => {
      const totalKeys = Object.values(state)
        .filter(cache => typeof cache === 'object' && cache !== state.stats)
        .reduce((sum, cache) => sum + Object.keys(cache).length, 0);

      state.healthParams = {};
      state.appointments = {};
      state.lipidProfile = {};
      state.medicalHistory = {};
      state.profiles = {};
      state.stats.invalidations += totalKeys;
    },

    // Reset cache statistics
    resetStats: (state) => {
      state.stats = {
        hits: 0,
        misses: 0,
        invalidations: 0
      };
    },

    // Cleanup expired entries
    cleanupExpiredEntries: (state, action) => {
      const { cacheType, expiryTime } = action.payload;

      if (state[cacheType]) {
        const now = Date.now();
        const validEntries = {};
        let expiredCount = 0;

        Object.entries(state[cacheType]).forEach(([key, entry]) => {
          if (entry.timestamp && (now - entry.timestamp) < expiryTime) {
            validEntries[key] = entry;
          } else {
            expiredCount++;
          }
        });

        state[cacheType] = validEntries;
        state.stats.invalidations += expiredCount;
      }
    },

    // Update cache statistics
    updateCacheStats: (state, action) => {
      const { type } = action.payload; // 'hit', 'miss', 'invalidation'

      if (type === 'hit') {
        state.stats.hits += 1;
      } else if (type === 'miss') {
        state.stats.misses += 1;
      } else if (type === 'invalidation') {
        state.stats.invalidations += 1;
      }
    }
  }
});

export const {
  setCacheEntry,
  getCacheEntry,
  removeCacheEntry,
  clearCacheType,
  invalidateByPattern,
  clearAllCache,
  resetStats,
  cleanupExpiredEntries,
  updateCacheStats
} = cacheSlice.actions;

// Selectors
export const selectCacheEntry = (state, cacheType, key) => {
  return state.cache[cacheType] && state.cache[cacheType][key];
};

export const selectCacheStats = (state) => state.cache.stats;

export const selectCacheHitRatio = (state) => {
  const { hits, misses } = state.cache.stats;
  const total = hits + misses;
  return total > 0 ? (hits / total * 100).toFixed(2) : 0;
};

export const selectCacheSizeByType = (state, cacheType) => {
  return state.cache[cacheType] ? Object.keys(state.cache[cacheType]).length : 0;
};

export default cacheSlice.reducer;
